export function formatRelativeTime(value?: string): string {
    if (!value) return "—";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;
    const diffMs = Date.now() - date.getTime();
    const upcoming = diffMs < 0;
    const minutes = Math.round(Math.abs(diffMs) / 60000);
    if (minutes < 1) return upcoming ? "in a moment" : "just now";
    if (minutes < 60) return upcoming ? `in ${minutes}m` : `${minutes}m ago`;
    const hours = Math.round(minutes / 60);
    if (hours < 24) return upcoming ? `in ${hours}h` : `${hours}h ago`;
    const days = Math.round(hours / 24);
    if (!upcoming && days === 1) return "yesterday";
    if (upcoming && days === 1) return "tomorrow";
    return upcoming ? `in ${days}d` : `${days}d ago`;
}
